import { render, staticRenderFns } from "./VBox.vue?vue&type=template&id=5f2837af&scoped=true&"
import script from "./VBox.vue?vue&type=script&lang=js&"
export * from "./VBox.vue?vue&type=script&lang=js&"
import style0 from "./VBox.vue?vue&type=style&index=0&id=5f2837af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2837af",
  null
  
)

export default component.exports